import React, { useEffect, useState } from "react";
import { AppLayout } from "../../../layouts";
import {
    Badges,
    Header,
    SearchBars,
    Sides,
    Tabbles,
} from "../../../components";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { actionDoctor } from "../../../redux/actions";
import { PiUserCircleLight, PiBinoculars } from "react-icons/pi";
import { LuFileSearch2 } from "react-icons/lu";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const MyPatients = ({ loginData }) => {
    const { t } = useTranslation();
    const [search, setSearch] = useState("");
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        //pageSize, currentPage, search, sortExp, sortDir, patientGuid, doctorGuid
        dispatch(
            actionDoctor.postDoctorsPatient(10, 1, "", "", "", "", loginData.userGuid)
        );
    }, [dispatch, loginData]);

    const postDoctorsPatientData = useSelector(
        (state) => state.doctor.postDoctorsPatientData?.data
    );

    const handleSearch = () => {
        dispatch(
            actionDoctor.postDoctorsPatient(10, 1, search, "", loginData.userGuid)
        );
    };
    const handlePatient = (patient) => { };

    const rightSide = (
        <Container fluid className="exado-container1">
            <Row className="exado-row1">
                <Col>
                    <Header.HeadingPage pageHeading={t("Patient.patients")} />
                </Col>
            </Row>
            <SearchBars.SearchBar
                className="search-bar"
                searchColmd={4}
                selectColxs={8}
                searchPlaceholder={t("Search") + " " + t("patient")}
                searchGrpClassName="form-group1"
                searchValue={search}
                onSearchChange={(e) => setSearch(e.target.value)}
                buttonColmd={3}
                buttonColxs={4}
                buttonClassname="btn-solid-Aqua_Teal"
                onSearchClick={handleSearch}
                buttonChildren={<PiBinoculars className="bionCularIcon" />}
            />
            <Row className="exado-row1">
                <Col>
                    <Tabbles.TableBlk
                        headerIcon={<PiUserCircleLight className="header-Icn" />}
                        heading={t("patient_list")}
                        columns={[
                            `${t("no")}`,
                            `${t("patient_name")}`,
                            `${t("phone_number")}`,
                            `${t("email")} ${t("Address")}`,
                            `${t("Nationality")}`,
                            `${t("Gender")}`,
                            `${t("details")}`,
                        ]}
                        data={postDoctorsPatientData?.result?.patientList?.map(
                            (patient, index) => ({
                                [t("no")]: index + 1,

                                [t("patient_name")]: (
                                    <div className="d-flex align-items-center">
                                        <Badges.Badge1
                                            text={patient.externalUser ? "G" : "E"}
                                            className={`ge-badge ${patient.externalUser ? "g-badge" : "e-badge"
                                                }`}
                                        />{" "}
                                        {patient.firstName + " " + patient.lastName}
                                    </div>
                                ),

                                [t("phone_number")]: patient.phone,
                                [`${t("email")} ${t("Address")}`]: patient.email,
                                [t("Nationality")]: patient.nationality,
                                [t("Gender")]:
                                    patient.gender == 1
                                        ? t("Male")
                                        : patient.gender == 2
                                            ? t("Female")
                                            : patient.gender == 3
                                                ? t("Other")
                                                : "",
                                [t("details")]: (
                                    <div className="editBlkIcon">
                                        <LuFileSearch2
                                            onClick={() =>
                                                navigate(`/doctor/patient-details/health-information`, {
                                                    state: { patient: patient },
                                                })
                                            }
                                            className="editIcon"
                                        />
                                    </div>
                                ),
                            })
                        )}
                        tabbleClassname="tabble"
                    />
                </Col>
            </Row>
        </Container>
    );
    return (
        <AppLayout.AppLayoutOne
            leftSide={<Sides.LeftSides loginData={loginData} />}
            rightSide={rightSide}
        />
    );
};

export default MyPatients;
